<template>
  <v-text-field
    v-bind="{...$attrs, ...propsVuetify}"
    type="text"
    :prefix="prefixo"
    v-bind:value="formatar(valor)"
    v-on="inputListeners"
    @keyup="$event.target.value = validaCaracteres($event)"
    @blur="$event.target.value = removerCasasIrrelevantes($event.target.value)"
  ></v-text-field>
</template>
<script>

export default {
  inheritAttrs: false,
  model: {
    prop: 'valor',
    event: 'input'
  },
  props: {
    valor: {
      require: false
    },
    maxDigitos: {
      type: Number,
      default: 4
    },
    inteiro: {
      type: Boolean,
      default: false
    },
    removerValorIrrelevante: {
      type: Boolean,
      default: false
    },
    propsVuetify: {
      type: Object,
      required: false
    },
    prefixo: {
      type: String,
      required: false,
      default: ''
    }
  },
  data() {
    return {
      init: true
    }
  },
  computed: {
    inputListeners: function () {
      var vm = this

      return Object.assign({},
        this.$listeners,
        {
          input: function (value) {
            const valorSemMascara = vm.removeMascara(value)

            vm.$emit('input', parseFloat(valorSemMascara))
          }
        }
      )
    }
  },
  methods: {
    formatar(value) {
      if (!value) return 0

      if (this.init && this.removerValorIrrelevante) {
        value = parseFloat(value)
      }

      let qtdeCasasDecimais = this.getQtdeCasasDecimais(value)

      if (qtdeCasasDecimais > this.maxDigitos && !this.inteiro) {
        qtdeCasasDecimais = this.maxDigitos
      }

      if (this.inteiro) {
        qtdeCasasDecimais = 0
      }

      const FORMATO = {
        style: "decimal",
        maximumFractionDigits: qtdeCasasDecimais,
        minimumFractionDigits: qtdeCasasDecimais
      }

      return new Intl
      .NumberFormat('pt-BR', FORMATO)
      .format(value);
    },
    getQtdeCasasDecimais(valor) {
      const indexPontoDecimal = ''.concat(valor).indexOf('.')

      if (indexPontoDecimal === -1) return 0

      return ''
      .concat(valor)
      .substring(indexPontoDecimal + 1)
        .length
    },
    removeMascara(valor) {
      return ''
      .concat(valor)
      .replace(/[.]/g, '')
      .replace(/[,]/g, '.')
    },
    validaCaracteres(event) {
      let removerCaracteres = /[a-zA-Z]/g

      if (this.inteiro) removerCaracteres = /[a-zA-Z,]/g

      return ''.concat(event.target.value)
      .replace(removerCaracteres, '')
      .replace(/,,/g, '')
    },
    removerCasasIrrelevantes(value) {
      if (!this.removerValorIrrelevante) return value

      if (this.init) this.init = false

      const VALOR_SEM_MASCARA = this.removeMascara(value)
      const VALOR_FLOAT = parseFloat(VALOR_SEM_MASCARA)

      return this.formatar(VALOR_FLOAT)
    }
  }
}
</script>
